import { css } from 'styled-components'
import { BlackText, GrayText, LightGrayText } from './colors'
import {
  AspiraBold,
  AspiraMedium,
  AspiraRegular,
  FontSize12,
  FontSize14,
  FontSize16,
  FontSize18,
  FontSize20,
  FontSize34,
  FontSize48,
} from './fonts'

/**
 * https://app.zeplin.io/project/5b71e2295bde783107ce2133/screen/5b71e267277f0d5b80d84c58
 * https://chegg.invisionapp.com/d/main#/console/15085059/313674042/preview
 *
 * The following partial definitions can be found in the Typographic Styles section of the above document
 */
export const HeroTitle = css`
  ${AspiraBold};
  ${FontSize48};
  ${BlackText};
`

export const Heading1 = css`
  ${AspiraMedium};
  ${FontSize34};
  ${BlackText};
`

export const Heading2 = css`
  ${AspiraMedium};
  ${FontSize20};
  ${BlackText};
`

export const Heading3 = css`
  ${AspiraMedium};
  ${FontSize18};
  ${BlackText};
`

export const Heading3Gray = css`
  ${AspiraMedium};
  ${FontSize18};
  ${GrayText};
`

export const BodyLargeBold = css`
  ${AspiraBold};
  ${FontSize16};
  ${BlackText};
`

export const BodyLargeMedium = css`
  ${AspiraMedium};
  ${FontSize16};
  ${BlackText};
`

export const BodyLarge = css`
  ${AspiraRegular};
  ${FontSize16};
  ${BlackText};
`

export const BodyLargeGray = css`
  ${AspiraRegular};
  ${FontSize16};
  ${GrayText};
`

export const BodyLargeLightGray = css`
  ${AspiraRegular};
  ${FontSize16};
  ${LightGrayText};
`

export const BodyBold = css`
  ${AspiraBold};
  ${FontSize14};
  ${BlackText};
`

export const BodyMedium = css`
  ${AspiraMedium};
  ${FontSize14};
  ${BlackText};
`

export const Body = css`
  ${AspiraRegular};
  ${FontSize14};
  ${BlackText};
`

export const BodyGray = css`
  ${AspiraRegular};
  ${FontSize14};
  ${GrayText};
`

export const BodyLightGray = css`
  ${AspiraRegular};
  ${FontSize14};
  ${LightGrayText};
`

export const BodySmall = css`
  ${AspiraRegular};
  ${FontSize12};
  ${BlackText};
`

export const BodySmallGray = css`
  ${AspiraRegular};
  ${FontSize12};
  ${GrayText};
`

export const BodySmallLightGray = css`
  ${AspiraRegular};
  ${FontSize12};
  ${LightGrayText};
`

// Special Cases

/**
 * Links
 *
 * https://chegg.invisionapp.com/d/main#/console/15085059/313674042/preview
 */

export const BodyLargeLink = css`
  ${AspiraMedium};
  ${FontSize16};
  color: ${({ theme }) => theme.Colors.linkColor};
`

export const BodyLink = css`
  ${AspiraMedium};
  ${FontSize14};
  color: ${({ theme }) => theme.Colors.linkColor};
`

export const BodySmallLink = css`
  ${AspiraMedium};
  ${FontSize12};
  color: ${({ theme }) => theme.Colors.linkColor};
`

export const SecondaryLink = css`
  ${AspiraRegular};
  ${FontSize14};
  color: ${({ theme }) => theme.Colors.secondaryLinkColor};
`

/**
 * TODO: [1] Figure out the rem/unitless values for this
 *
 * Values taken from:
 *    https://chegg.invisionapp.com/d/main#/console/15085059/313674039/inspect
 *    https://chegg.invisionapp.com/d/main#/console/15085059/313674035/inspect
 */

export const ButtonLarge = css`
  ${AspiraBold};
  font-size: 20px; /* [1] */
  line-height: 21px; /* [1] */
`
export const ButtonSmall = css`
  ${AspiraBold};
  font-size: 20px; /* [1] */
  line-height: 18px; /* [1] */
`
export const ButtonMini = css`
  ${AspiraBold};
  font-size: 16px; /* [1] */
  line-height: 16px; /* [1] */
`

export const InputLarge = css`
  ${AspiraRegular};
  font-size: 20px; /* [1] */
  line-height: 24px; /* [1] */
`

export const InputSmall = css`
  ${AspiraRegular};
  font-size: 16px; /* [1] */
  line-height: 19px; /* [1] */
`

export const InputMini = css`
  ${AspiraRegular};
  font-size: 13px; /* [1] */
  line-height: 16px; /* [1] */
`

// Utilities

export const Ellipsize = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
`
